import { FC, ReactElement } from 'react';
import { Link } from 'react-router-dom';

import { Box, Button } from '@bonusly/design-system';

interface Props {
	icon: ReactElement;
	label: string;
	to: string;
}

export const PageLink: FC<Props> = ({ icon, label, to }) => {
	// Check if this is an external URL
	const isExternalUrl = to.match(/^https?:\/\//);

	// Common button props
	const buttonProps = {
		colorScheme: 'secondary' as const,
		variant: 'ghost' as const,
		borderRadius: 'sm',
		h: 'auto',
		mb: 2,
		py: 1,
		px: 2,
		fontSize: 50,
		fontWeight: 'medium' as const,
		display: 'block',
		justifyContent: 'left',
		verticalAlign: 'middle',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		_hover: { bg: 'secondary.bgAlpha', '& .button-icon': { bg: 'bg.soft' } },
	};

	return (
		<Button as={isExternalUrl ? 'a' : Link} {...(isExternalUrl ? { href: to, target: '_blank', rel: 'noopener noreferrer' } : { to })} {...buttonProps}>
			<Box className="button-icon" h={8} w={8} borderRadius="full" bg="bg.subtle" verticalAlign="middle" textAlign="center" display="inline-block" mr={2}>
				{icon}
			</Box>
			{label}
		</Button>
	);
};
